<template>
  <div class="horse-item">
    <div class="ui-card border-style px-4 py-3">

      <div class="text-right">
        <span
          class="sp-btn-minus cp op4"
          @click="closeItem()"
          >
          <i class="fas fa-minus"></i>
        </span>
      </div>

      <div class="media">
        <div class="sp-avatar mr-4">
          <router-link 
            :to="{
              name: 'horse_item',
              params: {
                id: data.tokenID,
              },
            }"
            >
            <picColored
              :img="data.image_url ||'/static/img/lion_full.png'"
            />
          </router-link>
        </div>
        <div class="media-body">
          <div class="d-flex align-items-center mt-3">
            <div style="flex: 3;">
              <h5 class="b">
                {{data.horse_name}}
              </h5>
              <!-- <div>{{data}}</div> -->
            </div>
            <div  style="flex: 1;line-height: 16px;font-size: 12px;">
              <div class="op4">
                <small>
                  {{data.birthTime | stToDateTime}}
                </small>
              </div>
              <!-- <div>
                <a 
                  href="/" 
                  target="_blank"
                  class="text-c"
                  >
                  <small class="text-c">
                    12345678...
                  </small>
                </a>
              </div> -->
            </div>
          </div>

          <horseItemNumBlock class="mt-3" :data="data"/>
        </div>
      </div>
      
      <div class="d-flex align-items-center">

        <!-- detail -->
        <div class="mt-3" style="min-width: 100px;">
          <router-link 
            :to="{
              name: 'horse_item',
              params: {
                id: data.tokenID,
              },
            }"
            class="mr-3 op4"
            >
            <i class="fas fa-list mr-1 op4"></i>
            {{lg('',{
              en: 'Detail',
              zh: '',
            })}}
          </router-link>

          <span
            v-if="data.is_my && data.is_male && !data.is_in_stud"
            @click="$store.commit('setDataBusKey',{
              data_on_breed: data,
            })"
            class="cp op4"
            >
            <i class="fas fa-heart mr-1 op4"></i>
            {{lg('',{
              en: 'Breed',
              zh: '',
            })}}
          </span>

          <span
            v-if="data.is_my && !data.is_male && data.siringWithId > 0"
            @click="action_giveBirth()"
            class="cp op4"
            >
            <i class="fas fa-horse mr-1 op4"></i>
            {{lg('',{
              en: 'Birth',
              zh: '',
            })}}
          </span>

        </div>

        <!-- select mate -->
        <horseItemBlockSelectMate
          style="width: 100%;"
          v-if="cfg_show_breed_row || data.is_in_stud"
          :data="data"
        />
      </div>

      <!-- cancel breeding -->
      <!-- <div v-if="cfg_show_breed_row && data.is_myself" class="mt-3 ui-card p-3">
        <div class="d-flex align-items-center">
          <div class="ml-auto">
            <span
              @click="action_cancleAuction()"
              class="btn btn-primary"
              >
              {{lg('',{
                en: 'Cancel Breeding',
                zh: '',
              })}}
            </span>
          </div>
        </div>
      </div> -->

      <!-- <div class="mt-3">
        <button @click="action_createAuction()">createAuction</button>
        <button @click="action_cancleAuction()">cancleAuction</button>
        <button @click="action_bid()">bid</button>
        <button @click="action_giveBirth()">giveBirth</button>
      </div> -->
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import picColored from '@/views/_cp_base/pic_colored.vue'
import horseItemNumBlock from '@/views/_cp_busi/horse_item_num_block.vue'
import horseItemBlockSelectMate from '@/views/_cp_busi/horse_item_block_select_mate.vue'

export default {
  name: '',
  components: {
    horseItemNumBlock,
    picColored,
    horseItemBlockSelectMate,
  },
  props: [
    'data',
    'cfg_show_breed_row',
  ],
  data() {
    return {

    }
  },
  computed: {},
  watch: {},
  methods: {

    ...mapActions([
      'createAuction',
      'cancleAuction',
      'bid',
      'giveBirth',
    ]),

    action_createAuction(){
      let v = this
      v.createAuction(this.data)
    },
    action_cancleAuction(){
      let v = this
      v.cancleAuction(this.data)
    },
    action_bid(){
      let v = this
      v.bid(this.data)
    },
    action_giveBirth(){
      let v = this
      v.giveBirth(this.data)
    },

    closeItem(){
      if(this.$parent && this.$parent.status_show_more != undefined){
        this.$parent.status_show_more = false
      }
    },
  },
  created() {
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .horse-item{
    line-height: 1.5em;

    .sp-btn-minus{
      
    }

    .sp-avatar{
      width: 200px;
      height: 200px;
    }

  }
</style>